import { render, staticRenderFns } from "./AdminDoughnut.vue?vue&type=template&id=2a1e4cfa&"
import script from "./AdminDoughnut.vue?vue&type=script&lang=js&"
export * from "./AdminDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports